import React from 'react'

export default function CustomGridHeaderCell ({ title, onClick, children }) {
  return (
    <a className='k-link' onClick={onClick}>
      <span title={title}>{title}</span>
      {children}
    </a>
  )
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/BsrsGrid.HeaderCell.js